<div style="height:100%;" #map>
  <!-- TODO PS: Bild anzeigen wenn es Fehler mit der Map gibt -->
  <!--<img src="../../assets/tenants/kos/kosmap.jpg" style="width:100%;"/>-->
</div>


